import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.groups');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { TranslateService } from '@ngx-translate/core';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-groups',
template: templateSource || '',
    styles: [``],
})
export class PageKieraGroupsComponent implements OnInit {
    public list: any[] = [];
    public showAddModal: boolean = false;
    public newGroup: any = { name: "", description: "" };
    public selectionCatalog: any = {
        node: [],
        rack: [],
        zone: [],
        cluster: [],
    };
    public groupScope: any = this.emptyScope();
    public scopeTab: string = 'node';
    public scopeSearch: string = '';
    public loadingScope: boolean = false;
    public selectionCatalogLoaded: boolean = false;

    // Edit Modal
    public showEditModal: boolean = false;
    public editItem: any = null;

    // Sorting
    public sortField: string = 'name';
    public sortDir: string = 'asc';

    constructor(@Inject( Service) public service: Service,@Inject( TranslateService)  private translate: TranslateService) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("list");
        if (code === 200) {
            this.list = data;
            this.sortList();
        }
        await this.service.render();
    }

    public async addGroup() {
        if (!this.newGroup.name.trim()) return;
        const { code } = await wiz.call("create", {
            data: JSON.stringify({
                ...this.newGroup,
                scope: this.groupScope,
            }),
        });
        if (code === 200) {
            this.showAddModal = false;
            this.newGroup = { name: "", description: "" };
            this.groupScope = this.emptyScope();
            await this.load();
            await this.loadSelectionCatalog();
        }
    }

    public async openAddGroup() {
        this.newGroup = { name: "", description: "" };
        this.groupScope = this.emptyScope();
        this.scopeTab = 'node';
        this.scopeSearch = '';
        this.showAddModal = true;
        if (!this.selectionCatalogLoaded) {
            await this.loadSelectionCatalog();
        }
        await this.service.render();
    }

    public viewGroup(id: number) {
        this.service.href(`/kiera/groups/${id}`);
    }

    public async editGroup(item: any) {
        this.editItem = { ...item };
        this.groupScope = this.emptyScope();
        this.scopeTab = 'node';
        this.scopeSearch = '';
        this.showEditModal = true;
        if (!this.selectionCatalogLoaded) {
            await this.loadSelectionCatalog();
        }
        await this.service.render();
    }

    public async saveEdit() {
        if (!this.editItem) return;
        const { code } = await wiz.call("update", {
            id: this.editItem.id,
            data: JSON.stringify({
                ...this.editItem,
                scope: this.groupScope,
            }),
        });
        if (code === 200) {
            this.showEditModal = false;
            this.editItem = null;
            this.groupScope = this.emptyScope();
            await this.load();
            await this.loadSelectionCatalog();
        }
    }

    private emptyScope(): any {
        return {
            node: [],
            rack: [],
            zone: [],
            cluster: [],
        };
    }

    public async loadSelectionCatalog() {
        this.loadingScope = true;
        const { code, data } = await wiz.call("selection_catalog");
        if (code === 200) {
            this.selectionCatalog = {
                node: data?.nodes || [],
                rack: data?.racks || [],
                zone: data?.zones || [],
                cluster: data?.clusters || [],
            };
            this.selectionCatalogLoaded = true;
        }
        this.loadingScope = false;
        await this.service.render();
    }

    public async setScopeTab(tab: string) {
        this.scopeTab = tab;
        this.scopeSearch = '';
        await this.service.render();
    }

    public scopeItemId(type: string, item: any): number {
        if (type === 'rack') return Number(item?.rack_record_id || 0);
        return Number(item?.id || 0);
    }

    public scopeItemName(type: string, item: any): string {
        if (type === 'rack') return String(item?.rack_name || item?.rack_id || 'Rack');
        return String(item?.name || `${type} ${this.scopeItemId(type, item)}`);
    }

    public scopeItemMeta(type: string, item: any): string {
        if (type === 'node') return `${item?.group_name || 'Group 미할당'} · ${item?.status || '-'}`;
        if (type === 'rack') return `${item?.group_name || 'Group 미할당'} · ${item?.node_count || 0} nodes`;
        if (type === 'zone') return `${item?.location || '위치 미지정'} · ${item?.rack_count || 0} racks`;
        if (type === 'cluster') return `${item?.node_count || 0} nodes`;
        return '';
    }

    public get filteredScopeItems(): any[] {
        const term = this.scopeSearch.trim().toLowerCase();
        const rows = this.selectionCatalog[this.scopeTab] || [];
        return rows.filter((item: any) => {
            if (!term) return true;
            return [
                this.scopeItemName(this.scopeTab, item),
                this.scopeItemMeta(this.scopeTab, item),
            ].some((value: any) => String(value || '').toLowerCase().includes(term));
        });
    }

    public isScopeSelected(type: string, item: any): boolean {
        return (this.groupScope[type] || []).includes(
            this.scopeItemId(type, item)
        );
    }

    public async toggleScope(type: string, item: any) {
        const itemId = this.scopeItemId(type, item);
        if (itemId < 0 || (itemId === 0 && type !== 'zone')) return;
        const current = this.groupScope[type] || [];
        this.groupScope[type] = current.includes(itemId)
            ? current.filter((value: number) => value !== itemId)
            : [...current, itemId];
        await this.service.render();
    }

    public get scopeSelectionCount(): number {
        return Object.values(this.groupScope).reduce(
            (total: number, values: any) => total + (values || []).length,
            0,
        );
    }

    public clearScope() {
        this.groupScope = this.emptyScope();
        this.service.render();
    }

    public async deleteGroup(id: number) {
        if (!confirm(this.translate.instant('page.groups.confirm_delete'))) return;
        const { code, data } = await wiz.call("delete", { id });
        if (code !== 200) alert(data?.message || this.translate.instant('page.groups.delete_failed'));
        else await this.load();
    }

    public async setDefault(id: number) {
        const { code } = await wiz.call("set_default", { id });
        if (code === 200) await this.load();
    }

    // Import / Export
    public importing: boolean = false;

    public triggerImport() {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.json';
        input.onchange = async (e: any) => {
            const file = e.target.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = async (ev: any) => {
                try {
                    const data = JSON.parse(ev.target.result);
                    await this.performImport(data);
                } catch (err) {
                    alert('Invalid JSON file');
                }
            };
            reader.readAsText(file);
        };
        input.click();
    }

    private async performImport(data: any) {
        this.importing = true;
        await this.service.render();
        const { code, data: result } = await wiz.call("import_data", { data: JSON.stringify(data) });
        this.importing = false;
        if (code === 200) {
            const msg = `Import complete:\n- Groups created: ${result.groups_created}\n- Nodes created: ${result.nodes_created}\n- Nodes updated: ${result.nodes_updated}` +
                (result.errors?.length ? `\n- Errors: ${result.errors.join(', ')}` : '');
            alert(msg);
            await this.load();
        } else {
            alert('Import failed');
        }
        await this.service.render();
    }

    public async exportData() {
        const { code, data } = await wiz.call("export_data", {});
        if (code === 200) {
            const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `kiera-groups-export-${new Date().toISOString().slice(0, 10)}.json`;
            a.click();
            URL.revokeObjectURL(url);
        }
    }

    // ===== Sorting =====
    public async sort(field: string) {
        if (this.sortField === field) {
            this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortField = field;
            this.sortDir = 'asc';
        }
        this.sortList();
        await this.service.render();
    }

    private sortList() {
        const field = this.sortField;
        const dir = this.sortDir === 'asc' ? 1 : -1;
        this.list.sort((a: any, b: any) => {
            let va = a[field];
            let vb = b[field];
            if (va == null) va = '';
            if (vb == null) vb = '';
            if (field === 'id' || field === 'node_count' || field === 'default') {
                return (Number(va) - Number(vb)) * dir;
            }
            return String(va).localeCompare(String(vb)) * dir;
        });
    }

    public getSortIcon(field: string): string {
        if (this.sortField !== field) return 'bx-sort-alt-2';
        return this.sortDir === 'asc' ? 'bx-sort-up' : 'bx-sort-down';
    }
}

export default PageKieraGroupsComponent;
